export const STUDIO_EVENT_SLUG = 'danceana-studio-nobelova';
